// LoadingContext.js
import { createContext, Dispatch, FC, ReactNode, useState } from "react";

interface IReloadContext {
    reload: boolean;
    setReload: Dispatch<React.SetStateAction<boolean>>;
}

export const ReloadContext = createContext<IReloadContext | undefined>(
    undefined
);

export const ReloadProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [reload, setReload] = useState(false);
    const value = { reload, setReload };
    return (
        <ReloadContext.Provider value={value}>{children}</ReloadContext.Provider>
    );
};